import { render, staticRenderFns } from "./ISwitcher.vue?vue&type=template&id=77acdb47&"
import script from "./ISwitcher.vue?vue&type=script&lang=js&"
export * from "./ISwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ISwitcher.vue?vue&type=style&index=0&id=77acdb47&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports